export default {
	dailyActivity: {
		dateSheetTitle: 'Select date',
		deletedRecordFallbackModule: 'Record',
		deletedRecordTitle: '{module} (deleted)',
		descriptor: {
			archive_archived: '{title} was archived',
			archive_unarchived: '{title} was unarchived',
			globalization_added: '{title} was shared with {user}',
			globalization_message_changed: 'The sharing message for {title} was changed',
			globalization_removed: '{title} is no longer shared with {user}',
			ido_added: '{title} was linked to record {idoTitle}',
			ido_removed: 'The link between {title} and record {idoTitle} was removed',
			status_ready: 'The status of {title} was set to {status}',
			status_seen: 'The status of {title} was set to {status}',
			status_unseen: 'The status of {title} was set to {status}',
			unknown: 'Changed {title}',
		},
		editHistoryLoading: 'Loading changes…',
		emptyTitle: 'No changes on this day',
		errorTitle: 'Could not load actions',
		export: {
			columnAction: 'Action',
			columnModule: 'Module',
			columnTime: 'Time',
		},
		filterArchive: 'Archived',
		filterIdoEdit: 'Record edited',
		filterLink: 'Link',
		filterSectionActions: 'Actions',
		filterSectionModules: 'Modules',
		filterShare: 'Shared',
		filterStatus: 'Status',
		filterTooltip: 'Filter',
		historyExpand: 'History',
		hourActivityCount: '{count} actions',
		hourSuffix: '{hour}:00',
		idoDeleted: 'The record {idoTitle} was deleted',
		idoEditedNamed: 'The values {fields} were changed in record {idoTitle}',
		idoEditedNamedOne: 'The value {fields} was changed in record {idoTitle}',
		idoEditedOne: '1 value was changed in record {idoTitle}',
		idoEditedOther: '{count} values were changed in record {idoTitle}',
		loading: 'Loading actions…',
		moduleLabel: {
			activity: 'Activity',
			appointment: 'Appointment',
			document: 'Document',
			email: 'Email',
			ido: 'Record',
			message: 'Message',
			note: 'Note',
			phonecall: 'Phone call',
			task: 'Task',
		},
		nextDay: 'Next day',
		openIdo: 'Open record',
		prevDay: 'Previous day',
		retry: 'Try again',
		searchPlaceholder: 'Search actions …',
		searchPlaceholderShort: 'Search …',
		statusValue: {
			ready: 'Ready',
			seen: 'In Progress',
			unseen: 'Unviewed',
		},
		title: 'Daily Actions',
		today: 'Today',
		typeLabel: {
			archive_archived: 'Archived',
			archive_unarchived: 'Unarchived',
			globalization_added: 'Shared',
			globalization_message_changed: 'Message',
			globalization_removed: 'Unshared',
			ido_added: 'Linked',
			ido_removed: 'Unlinked',
			idoEdit_deleted: 'Record deleted',
			idoEdit_edited: 'Record edited',
			status_ready: 'Ready',
			status_seen: 'In Progress',
			status_unseen: 'Unviewed',
		},
		userSelectSelf: 'My actions',
		userSelectSheetTitle: 'User selection',
	},
};
